import { useEffect, useRef, type ReactNode } from "react";
import { Link } from "react-router";
import s from "./ui.module.css";

/* Klickbare Karte (BAUPLAN-FLAECHEN.md, Abschnitt 3.2, ADR-020): wie Karte, aber die ganze Fläche ist ein Link von react-router.
   Beim Zeigen hebt sie sich (--schatten-2), mit Tastatur bekommt sie einen Fokusrahmen.

   Regel: In einer klickbaren Karte stehen keine weiteren Knöpfe oder Links. Ein Link darf nichts Klickbares enthalten, und wer die
   Karte antippt, soll nicht raten müssen, was passiert. Im Entwicklungsmodus warnt die Komponente in der Konsole. Braucht eine Karte
   einen Knopf, ist sie eine normale Karte.

   Name für Screenreader: `label` (aria-label) oder `titelId` (die Überschrift in der Karte, aria-labelledby). Ohne beides liest der
   Screenreader den ganzen Text der Karte vor. */

export const PFEIL = (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

const KLICKBAR = "a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex='-1'])";

export function KarteLink({
  to,
  label,
  titelId,
  weiter,
  fussLinks,
  className,
  children,
}: {
  to: string;
  label?: string;
  titelId?: string;
  /** Ziel als Text unten in der Karte, zum Beispiel „Öffnen“ oder „Zur Sitzung“, mit Pfeil */
  weiter?: string;
  /** Fuß mit Trennlinie: links zum Beispiel die eigene Rolle als Marke, rechts das Ziel (weiter). Nichts Klickbares. */
  fussLinks?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  const ref = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    if (import.meta.env.DEV && ref.current?.querySelector(KLICKBAR))
      console.warn(`KarteLink (${to}): keine Knöpfe oder Links in einer klickbaren Karte`);
  });
  return (
    <Link
      ref={ref}
      to={to}
      aria-label={label}
      aria-labelledby={label ? undefined : titelId}
      className={[s.karte, s.karteLink, className].filter(Boolean).join(" ")}
    >
      {children}
      {fussLinks ? (
        <span className={s.karteFuss}>
          {fussLinks}
          {weiter ? (
            <span className={s.karteWeiter}>
              {weiter} {PFEIL}
            </span>
          ) : null}
        </span>
      ) : weiter ? (
        <span className={s.karteWeiter}>
          {weiter} {PFEIL}
        </span>
      ) : null}
    </Link>
  );
}
